import { NgOptimizedImage } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { LucideMenu } from '@lucide/angular';
import {
  NbButtonModule,
  NbDialogService,
  NbIconModule,
  NbLayoutModule,
  NbMenuService,
  NbSidebarModule,
  NbSidebarService,
} from '@nebular/theme';
import { Subscription } from 'rxjs';

import { SidebarMenuService } from '../../../shared/services/sidebar-menu.service';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  templateUrl: './one-column.layout.html',
  imports: [NbLayoutModule, NbSidebarModule, NbIconModule, RouterOutlet, NbButtonModule, LucideMenu, NgOptimizedImage],
})
export class OneColumnLayoutComponent implements OnInit, OnDestroy {
  private sidebarService = inject(NbSidebarService);
  private router = inject(Router);
  private nbMenuService = inject(NbMenuService);
  private sidebarMenuService = inject(SidebarMenuService);

  public fullname: string;
  public sideMenuExpanded: boolean = true;

  // TODO: make it modal-like instead of using subheadermode?
  public subheadermode: string = 'account-view';
  menu_click_subscription: Subscription;

  constructor() {
    this.checkRouterUrl(this.router.url);
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkRouterUrl(event.url);
        this.setSidebar(event.url);
      }
    });

    this.nbMenuService.onSubmenuToggle().subscribe((event) => {
      if (!this.sideMenuExpanded) {
        this.sideMenuExpanded = true;
        this.sidebarMenuService.saveSideBarMenu(this.sideMenuExpanded);
      }
    });

    this.sidebarService.onToggle().subscribe((res) => {
      this.sideMenuExpanded = !this.sideMenuExpanded;
      this.sidebarMenuService.saveSideBarMenu(this.sideMenuExpanded);
    });

    this.setSidebar(this.router.url);
  }

  ngOnDestroy() {
    this.menu_click_subscription.unsubscribe();
  }

  checkRouterUrl(url) {
    if (url.startsWith('/account')) {
      this.subheadermode = 'account-view';
    } else if (url.startsWith('smart-flow/flow/')) {
      this.subheadermode = 'flow-view';
    } else {
      this.subheadermode = 'tabs-view';
    }
  }

  setSidebar(url: string) {
    if (url.startsWith('/smart-flow/flow/')) {
      // in a set time out since initially UI needs to be
      // rendered and initial state must be set or the state below would just get
      // overwritten.
      setTimeout(() => {
        this.sidebarService.compact('menu-sidebar');
        this.sideMenuExpanded = false;
        this.sidebarMenuService.saveSideBarMenu(this.sideMenuExpanded);
      });
    }
  }
}
